import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { SAVE_QUESTION_RESULT_MUTATION } from 'src/graphql/job/mutation';

export default () => {
  const [saveQuestionResult] = useMutation(SAVE_QUESTION_RESULT_MUTATION);

  return useCallback(
    ({ jobId, checklistQuestionResult, datasheetQuestionResult, ...rest }) =>
      saveQuestionResult({
        variables: {
          ...rest,
          jobId,
          checklistQuestionResult: checklistQuestionResult || null,
          datasheetQuestionResult: datasheetQuestionResult
            ? [datasheetQuestionResult].map(({ result, ...rest2 }) => ({
              ...rest2,
              result: JSON.stringify(result),
            }))[0]
            : null,
        },
      }),
    [],
  );
};
